import { render, staticRenderFns } from "./info-index.vue?vue&type=template&id=e83edbf2&scoped=true&"
import script from "./info-index.vue?vue&type=script&lang=js&"
export * from "./info-index.vue?vue&type=script&lang=js&"
import style0 from "./info-index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./info-index.vue?vue&type=style&index=1&id=e83edbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83edbf2",
  null
  
)

export default component.exports